import PropTypes from "prop-types";

import ChallengesTeacherTab from "../ChallengesTeacherTab";
import {
  containerWrapper,
  containerList,
} from "./ChallengesTeacherTabsContainer.style";

const propTypes = {
  activeTab: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  setActiveTab: PropTypes.func,
  activeData: PropTypes.any,
};

const ChallengesTeacherTabsContainer = ({
  activeTab,
  options,
  setActiveTab,
}) => {
  const handleOptionSelection = (option) => {
    setActiveTab(option);
  };

  if (options?.length <= 1) return null;

  const renderTabs = () => {
    return options?.map((option, index) => {
      return (
        <ChallengesTeacherTab
          key={`${option}-tab-${index}`}
          activeTab={activeTab}
          handleOptionSelection={handleOptionSelection}
          tabName={option}
        />
      );
    });
  };

  return (
    <div css={containerWrapper}>
      <div css={containerList} role="tablist" aria-labelledby="tablist">
        {renderTabs()}
      </div>
    </div>
  );
};

ChallengesTeacherTabsContainer.propTypes = propTypes;

export default ChallengesTeacherTabsContainer;
